<template>
  <div class="flex flex-row flex-grow space-x-10 px-10 h-full">
    <template v-if="shown">
      <div class="py-10 flex flex-grow flex-col space-y-20 overflow-y-auto">
        <h1 class="text-24px leading-24px font-bold">Почта успешно подтверждена</h1>
        <div class="flex flex-col flex-grow items-start justify-center max-w-lg space-y-6">
          <img src="@/assets/icons/done.svg" alt="">
          <b class="text-22px leading-26px font-bold">
            Почта подтверждена. Ваш аккаунт проходит верификацию менеджером сервиса.
            Вы будете уведомлены о результатах верификации.
          </b>
          <span>
            Скачайте приложение IWALY перейдя по ссылке ниже
          </span>
          <div class="flex flex-col space-y-4 md:space-y-0 md:flex-row md:space-x-4">
            <a href="https://apps.apple.com/ru/app/iwaly-деликатный-сервис-1/id1508526621">
              <img class="cursor-pointer" src="@/assets/icons/app-store.svg" alt="">
            </a>
            <a href="https://play.google.com/store/apps/details?id=app.iwaly">
              <img class="cursor-pointer" src="@/assets/icons/google-play.svg" alt="">
            </a>
            <a href="https://appgallery.huawei.com/#/app/C103136791">
              <img class="cursor-pointer" src="@/assets/icons/huawei-app-gallery.svg" alt="">
            </a>
          </div>
        </div>
      </div>
      <div class="hidden lg:flex flex-row items-stretch py-10 space-x-12">
        <div class="w-64 rounded-lg overflow-hidden">
          <img
            class="h-full object-center object-cover w-full"
            src="@/assets/images/poster-2.png">
        </div>
        <div class="w-64 rounded-lg overflow-hidden">
          <img
            class="h-full object-center object-cover w-full"
            src="@/assets/images/poster-1.png">
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      shown: false,
    };
  },
  computed: {
    token() {
      return this.$route.params.token;
    },
  },
  methods: {
    ...mapActions({
      VERIFY_EMAIL: 'ACT_VERIFY_EMAIL',
    }),
  },
  watch: {
    token: {
      handler(value) {
        if (value) {
          this.VERIFY_EMAIL(value).then(() => {
            this.shown = true;
          }).catch(() => {
            setTimeout(() => {
              window.location.href = '/';
            }, 3000);
          });
        }
      },
      immediate: true,
    },
  },
};
</script>
